import {headerName} from '@telstra-connect/utils/helper/common-static-data'

export const getTileName = () => {
  const tileName = headerName.networksAndInternet
  return tileName
}

export const getTileNameInt = () => {
  const tileName = headerName.networksAndInternetInt
  return tileName
}
export const getTileNameYPandSInt = () => {
  const tileName = headerName.yourProductsAndServicesInt
  return tileName
}
